import { Component, Input } from '@angular/core';
import { DialogService } from '@frk/eds-components';
import { PortfolioHedgeManagerAllocations } from '@models';
import { BaseProductDetailComponent } from '@products/base-product-detail.component';
import { TranslateService } from '@shared/translate/translate.service';
import { PortfolioDisplay } from '@types';

@Component({
  selector: 'ft-manager-roster',
  templateUrl: './manager-roster.component.html',
  styleUrls: ['./manager-roster.component.scss'],
})
export class ManagerRosterComponent
  extends BaseProductDetailComponent
  implements PortfolioDisplay {
  isPopulated = false;
  managerRosterList;

  @Input() data: PortfolioHedgeManagerAllocations;

  constructor(
    private translateService: TranslateService,
    private dialogService: DialogService
  ) {
    super();
  }

  processData() {
    const { managerRosterList } = this.component.getModels();
    this.page
      .getContent(managerRosterList)
      ?.getData()
      ?.managerRoster?.forEach((manager) => {
        for (const strategy of this.data.strategies) {
          const found = strategy.allocations.find(
            (alloc) => alloc.managerRoster === manager.name
          );
          if (found) {
            found.displayName = manager.displayName;
            found.longDescription = manager.longDescription;
            found.shortDescription = manager.shortDescription;
            const widenAsset = manager.image?.widenAsset;
            if (widenAsset) {
              const imageData = JSON.parse(widenAsset);
              found.imageSrc = imageData.url;
            }
            break;
          }
        }
      });

    this.isPopulated = true;
  }

  showPopup(event: MouseEvent, manager) {
    event.preventDefault();
    const popupConfig = {
      closeBtnLabel: this.translateService.instant('common.close'),
      title: manager.displayName ? manager.displayName : manager.managerRoster,
      content: manager.imageSrc
        ? `<image src="${manager.imageSrc}" alt=""/><br />${manager.longDescription}`
        : manager.longDescription,
      hideFooter: true,
    };
    this.dialogService.open('managerRosterPopup', popupConfig);
  }
}
